<template>
    <nav
        role="navigation"
        class="ml-2 border-l-2 border-white/10 pb-1 pl-2 pr-1"
    >
        <ul class="flex flex-col">
            <li class="group mb-1 flex flex-wrap">
                <NavigationLink
                    label="Conf/Team"
                    :link="
                        route('wbbschedules', {
                            conference:
                                selectedConference?.slug ?? 'america-east',
                            team:
                                selectedTeam?.short_name?.toLowerCase() ??
                                'all',
                        })
                    "
                    :icon="selectedTeam?.logo ?? 'notebook.png'"
                    component="WBB"
                    :tabindex="0"
                />
            </li>
            <li class="group mb-1 flex flex-wrap">
                <NavigationLink
                    label="Standings"
                    :link="route('wbbstandings')"
                    icon="trophy.png"
                    component="WBBStandings"
                    :tabindex="0"
                />
            </li>
            <li
                v-if="['WBBStandings'].indexOf($page.component) < 0"
                class="mt-1 w-full px-1"
            >
                <label for="wbbTeamSelector" class="text-xxs uppercase"
                    >Conf/Team</label
                ><br />
                <select
                    id="wbbTeamSelector"
                    class="w-full bg-slate-300 p-1 text-xs text-slate-900"
                    v-model="selectedTeam"
                    @change="setTeam"
                >
                    <option
                        v-for="t in teamsAndConfs"
                        :key="JSON.stringify(t.value)"
                        :value="t.value"
                    >
                        {{ t.name }}
                    </option>
                </select>
            </li>
        </ul>
    </nav>
</template>

<script>
import BasketballNavigationLink from './BasketballNavigationLink.vue';
import { mapWritableState } from 'pinia';
import { useGeneralStore } from '@/utils/useGeneralStore';
import { router } from '@inertiajs/vue3';
import * as DataService from '@/DataService';

export default {
    name: 'WBasketballNavigation',
    props: ['conference', 'team'],
    components: { NavigationLink: BasketballNavigationLink },
    computed: {
        ...mapWritableState(useGeneralStore, ['showMobile']),
    },
    data() {
        return {
            selectedConference: null,
            selectedTeam: null,
            teamsAndConfs: [],
        };
    },
    created() {
        this.fetchTeamsAndConfs();
    },
    mounted() {
        if (this.conference) {
            this.selectedConference = this.conference;
        }
        if (this.team && this.team.short_name !== 'ALL') {
            this.selectedTeam = this.team;
        }
    },
    methods: {
        fetchTeamsAndConfs() {
            DataService.client.get('/api/wbb-teams-and-confs').then((d) => {
                this.teamsAndConfs = d.data;
            });
        },
        linkWrapClass() {
            return 'flex flex-wrap group mb-2 flex-1';
        },
        setTeam() {
            if (this.selectedTeam && typeof this.selectedTeam === 'object') {
                router.visit(
                    route('wbbschedules', {
                        conference: this.selectedTeam.conf,
                        team: this.selectedTeam.team,
                    }),
                );
            }
        },
    },
};
</script>
